import authService from './authService'

export default authService



// WEBPACK FOOTER //
// ../src/services/authService/index.js